
import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TableContainer,
  Paper,
  TextField,
  Box,
  Button,CircularProgress
} from "@mui/material";
import { GlobalStyles } from "@mui/system";
import { useAuth } from "../../../../AuthProvider";



const baseUrl = process.env.REACT_APP_API_BASE_URL;
function ScheduleNoticeBoard() {
  const {pId,oId}=useAuth();
  const [notices, setNotices] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingNotices, setLoadingNotices] = useState(true); // ✅ Define loading state


  const fetchNotices = async () => {
    setLoadingNotices(true); // Start loading
    try {
      const response = await fetch(`${baseUrl}/api/noticeBoard/getAll/${oId}/${pId}`); // Replace with your API URL
      const data = await response.json();
      // ✅ Sort notices by purposeDate (future dates first)
      data.sort((a, b) => new Date(b.purposeDate) - new Date(a.purposeDate));

      setNotices(data); // Assuming the response is an array
    } catch (error) {
      console.error("Error fetching notices:", error);
    }finally {
      setLoadingNotices(false); // Stop loading
    }

  };
useEffect(() => {
  fetchNotices();
}, []);


 // Filter notices based on search query
 const filteredNotices = notices.filter((notice) => {
  return (
    notice.title.toLowerCase().includes(searchQuery.toLowerCase()) || 
    notice.purposeDate.toLowerCase().includes(searchQuery.toLowerCase())
    
  );
});



  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent>
        {/* Title Section */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              NoticeBoard
            </Typography>
          </Grid>
        </Grid>

       
        {/* Two Side-by-Side Boxes */}
        <Grid container spacing={2} sx={{ marginTop: "1px" }}> {/* Reduced margin between table and filter boxes */}
         

          {/* box 2 */}
          <Grid item xs={12} >
       
  {/* Scrollable Container */}
  <Box
  sx={{
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
    backgroundColor: "#f9f9f9",
  }}
>
  <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}>
    Scheduled Notices
  </Typography>

  {/* Search by Date and Title */}
  {/* Search Input */}
  <Grid container  sx={{ marginBottom: "15px" }}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Search by Date or Title"
            fullWidth
            size="small"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Grid>
      </Grid>

  {/* Horizontal Line */}
  <Box sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }} />
  <GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

  {/* Scrollable Container */}
  <Box sx={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }} className="custom-sidebar-scrollbar">
      <Grid container spacing={2}>

        {loadingNotices ? ( // Show loader when loading
              <Box display="flex" flexDirection="column" alignItems="center" width="100%" sx={{ mt: 2 }}>
                <CircularProgress />
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Loading Notices...
                </Typography>
              </Box>
             ) : filteredNotices.length === 0 ? (
          <Typography
            variant="h6"
            sx={{ textAlign: "center", color: "#666", width: "100%", padding: "20px", fontStyle: "italic" }}
          >
            No notices available.
          </Typography>
        ) : (
          filteredNotices.map((data, index) => (
            <Grid item xs={12} key={index}>
                <Box
                 
                  sx={{
                    padding: "10px",
                    borderRadius: "10px",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#D1E9F6",
                    position: "relative",
                    overflow: "hidden",
                    marginTop: "10px",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      backgroundColor: "#b3d8ec",
                    },
                  }}
                >
                  {/* "New!" Ribbon Badge - Properly Aligned */}
                  {new Date() - new Date(data.purposeDate) < 24 * 60 * 60 * 1000 && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "0",
                        right: "0",
                        backgroundColor: "blue",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "0.75rem",
                        padding: "6px 12px",
                        textTransform: "uppercase",
                        borderTopRightRadius: "8px",
                        borderBottomLeftRadius: "8px",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      New!
                    </Box>
                  )}

  

<div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Box
                  sx={{
                    backgroundColor: "#4CAF50",
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "10px",
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    "&:hover": {
                      backgroundColor: "#388E3C",
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  {data.purposeDate}
                </Box>
            
                {/* <Box
                  sx={{
                    backgroundColor: "#4682B4",
                    color: "#fff",
                    borderRadius: "8px",
                    padding: "10px",
                    fontSize: "0.9rem",
                    fontWeight: "bold",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  {data.time}
                </Box> */}
              </div>

              {/* Title in single row */}
             <Box sx={{ marginTop: "10px", display: "flex", alignItems: "center", gap: 1 }}>
               <Typography
                 variant="h6"
                 sx={{ fontWeight: "bold", color: "#444" }}
               >
                 Notice:
               </Typography>
               <Typography
                 variant="h5"
                 sx={{ fontWeight: "bold", color: "#333" }}
               >
                 {data.title}
               </Typography>
             </Box>
             
             {/* Purpose stacked */}
             <Box sx={{ marginTop: "10px" }}>
               <Typography
                 variant="h6"
                 sx={{ fontWeight: "bold", color: "#444" }}
               >
                 Notice Purpose:
               </Typography>
               <Typography
                 variant="body2"
                 sx={{ color: "#666", fontWeight: "bold" }}
               >
                 {data.description}
               </Typography>
             </Box>
           





                </Box>

            </Grid>
          ))
        )}
      </Grid>
    </Box>


    
</Box>



 
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default ScheduleNoticeBoard;